import { MouseEventHandler, useId } from 'react';
import ConditionalWrapper from '../ConditionalWrapper';
import { SCard } from '../s-polaris';

const SelectionCard: React.FC<SelectionCardProps> = (props) => {
    const id = useId();
    return (
        <ConditionalWrapper
            condition={!!props.tooltip?.length}
            wrapper={(c) => (
                <div className="grid relative">
                    <s-clickable
                        disabled={props?.disabled}
                        interestFor={id}
                        blockSize="100%"
                        inlineSize="100%"
                        background="transparent"
                    >
                        <div className="h-full grid">{c}</div>
                    </s-clickable>
                    <s-tooltip id={id}>{props.tooltip}</s-tooltip>
                </div>
            )}
        >
            <SCard padding="0">
                <div
                    className="selection-card"
                    data-selected={props.selected ? '' : undefined}
                    data-disabled={props.disabled ? '' : undefined}
                    onClick={!props.disabled && props.onClick}
                >
                    {props.children}
                </div>
            </SCard>
        </ConditionalWrapper>
    );
};

export default SelectionCard;

interface SelectionCardProps {
    selected: boolean;
    onClick: MouseEventHandler<HTMLDivElement>;
    children: React.ReactElement;
    disabled?: boolean;
    tooltip?: string;
}
